import React, { createContext, useState, ReactNode, useEffect } from 'react';
import { number } from 'yup';

interface PrintContextProps {
  isPrinting: boolean;
  setIsPrinting: (val: boolean) => void;
  isPrintMenuOpen: boolean;
  setIsPrintMenuOpen: (val: boolean) => void;
  reportType: 'summary' | 'details' | 'unset';
  setReportType: (type: 'summary' | 'details' | 'unset') => void;
  progress: number | undefined;
  setProgress: React.Dispatch<React.SetStateAction<number | undefined>>
}

export const PrintContext = createContext<PrintContextProps>({
  isPrinting: false,
  setIsPrinting: () => {/* NO OP */},
  isPrintMenuOpen: false,
  setIsPrintMenuOpen: () => {/* NO OP */},
  reportType: 'unset',
  setReportType: () => {/* NO OP */},
  progress: undefined,
  setProgress: () => {/* NO OP */},
});

export const PrintContextProvider = ({ children }: { children: ReactNode }) => {
  const [isPrinting, setIsPrinting] = useState(false);
  const [isPrintMenuOpen, setIsPrintMenuOpen] = useState(false);
  const [reportType, setReportType] = useState<'summary' | 'details' | 'unset'>('unset');
  const [progress, setProgress] = useState<number | undefined>(undefined);


  return (
    <PrintContext.Provider value={{ isPrinting, setIsPrinting, isPrintMenuOpen, setIsPrintMenuOpen, reportType, setReportType, progress, setProgress }}>
      {children}
    </PrintContext.Provider>
  );
};
